<template>
  <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>{{ poll.name }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form ref="createPoll">
        <v-text-field
          v-model="poll.name"
          name="name"
          :rules="rules.required"
          label="Название"
        ></v-text-field>
        <v-switch
          v-model="poll.active"
          color="green"
          name="is_active"
          :label="switchText"
        ></v-switch>
        <v-row justify="space-between">
          <v-btn @click="save" color="green" :dark="pollWasChanged" :disabled="!pollWasChanged">{{
            saveButtonText
          }}</v-btn>
          <v-btn v-if="isEdit" @click="deletePoll" color="red" outlined>Удалить</v-btn>
        </v-row>
      </v-form>
      <v-col v-if="isEdit">
        <v-row>
          <v-list>
            <v-subheader>вопросы к тесту</v-subheader>
            <v-list-item v-for="q in questions" :key="q.id + 'list'" @click="selectQuestion(q)">
              <v-list-item-icon>{{ q.sort }}</v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ q.text }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon
                ><v-icon color="red" @click.stop="deleteQuestion(q)"
                  >mdi-close-circle-outline</v-icon
                ></v-list-item-icon
              >
            </v-list-item>
          </v-list>
        </v-row>
        <v-dialog v-model="questionModal" max-width="600">
          <Question
            :poll-id="poll.id"
            :initial-question="currentEditableQuestion"
            @question-created="questionUpdated"
            @question-updated="questionUpdated"
          ></Question>
        </v-dialog>
      </v-col>
      <v-col cols="12" v-if="isEdit">
        <v-btn color="primary" outlined @click="addNewQuestion">добавить вопрос</v-btn>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import * as pollAPI from '@/api/polls'
import forms from '@/mixins/forms'
import Question from '@/components/polls/Question'

export default {
  name: 'Poll',
  components: { Question },
  mixins: [forms],
  props: {
    type: { type: String, required: true },
    id: { type: String, required: false, default: '' },
  },
  data() {
    return {
      questionModal: false,
      currentEditableQuestion: { ...pollAPI.DEFAULT_QUESTION },
      objectId: '',
      originalPoll: { ...pollAPI.DEFAULT_POLL },
      poll: { ...pollAPI.DEFAULT_POLL },
    }
  },
  computed: {
    pollWasChanged() {
      return !(
        this.poll.active === this.originalPoll.active && this.poll.name === this.originalPoll.name
      )
    },
    switchText() {
      if (this.poll.active) {
        return 'Активен'
      }
      return 'Не активен'
    },
    saveButtonText() {
      if (this.isEdit) {
        return 'Обновить'
      }
      return 'Сохранить'
    },
    questions() {
      if (this.poll.questions) {
        return this.poll.questions.sort((a, b) => {
          if (a.sort > b.sort) {
            return 1
          }
          if (a.sort < b.sort) {
            return -1
          }
          return 0
        })
      }
      return []
    },
    hasQuestions() {
      return this.poll.questions && this.poll.questions.length > 0
    },
    isEdit() {
      return !!this.poll.id
    },
  },
  mounted() {
    this.objectId = this.id
    this.getPoll()
  },
  methods: {
    deletePoll() {
      if (!this.poll.id) {
        return
      }
      pollAPI
        .deletePoll(this.axios, this.poll.id)
        .then((resp) => {
          this.showSnackbar(`Удалено`, 'success')
          this.poll = { ...pollAPI.DEFAULT_POLL }
        })
        .catch((err) => this.showSnackbar(err, 'error'))
    },
    save() {
      if (this.isEdit) {
        this.updatePoll()
      } else {
        this.createPoll()
      }
    },
    deleteQuestion(question) {
      pollAPI
        .deletePollQuestion(this.axios, question.id)
        .then((resp) => {
          this.showSnackbar(`вопрос ${question.text} был удален`, 'success')
          this.getPoll()
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
    addNewQuestion() {
      this.currentEditableQuestion = { ...pollAPI.DEFAULT_QUESTION }
      this.questionModal = true
    },
    createPoll() {
      if (!this.$refs.createPoll.validate()) {
        this.showSnackbar(this.messages.needFillAllRequiredFields, 'error')
        return
      }
      pollAPI
        .createPoll(this.axios, this.type, this.objectId, this.poll.name, this.poll.active)
        .then((resp) => {
          this.poll = resp.data
          this.originalPoll = { ...this.poll }
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updatePoll() {
      pollAPI
        .updatePoll(this.axios, this.poll.id, {
          name: this.poll.name,
          active: this.poll.active,
        })
        .then((resp) => {
          this.getPoll()
          this.showSnackbar(this.messages.successUpdated, 'success')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    getPoll() {
      pollAPI
        .getPoll(this.axios, this.type, this.objectId)
        .then((resp) => {
          if (resp.status === 204) {
            return
          }
          this.poll = resp.data
          this.originalPoll = { ...this.poll }
        })
        .catch((err) => {
          if (err.status === 204) {
            return
          }
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    selectQuestion(question) {
      this.currentEditableQuestion = { ...question }
      this.questionModal = !this.questionModal
    },
    questionUpdated() {
      this.getPoll()
    },
  },
}
</script>
